// extracted by mini-css-extract-plugin
export default {"buttons":"archive_buttons__gZRJQ","active":"archive_active__nXnZD","icon":"archive_icon__sMyQL"};